import numeral from 'numeral';

export default (value: string | number, format: string): string =>
  numeral(value).format(format);
